// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"2fdf1cab","60":"d41fdd93","372":"15dbd83b","376":"eeefa8d4","487":"fc352e3d","536":"f9172d76","556":"17fa0694","714":"2b389ad1","787":"fc9ca18f","818":"1c2ba12e","908":"a6e88736","924":"a47ef9b3"}[chunkId] + ".chunk.css";
};